import { render, staticRenderFns } from "./CupomDelivery.vue?vue&type=template&id=47b64665&scoped=true"
import script from "./CupomDelivery.vue?vue&type=script&lang=js"
export * from "./CupomDelivery.vue?vue&type=script&lang=js"
import style0 from "./CupomDelivery.vue?vue&type=style&index=0&id=47b64665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b64665",
  null
  
)

export default component.exports